<template>
  <div
    class="flex flex-col gap-3 px-4 pt-3 bg-white rounded-t-[16px] shadow-[0_-2px_10px_rgba(0,0,0,0.08)]"
    style="
      padding-bottom: calc(12px + var(--ion-safe-area-bottom, env(safe-area-inset-bottom, 0px)));
    "
  >
    <!-- Tier 1: Main mode tabs -->
    <div class="flex bg-[#F0F0F0] rounded-[10px] p-[3px]">
      <button
        class="flex-1 py-2 rounded-[8px] text-[0.8125rem] font-semibold transition-all"
        :class="mode === 'position' ? 'text-[#8C8C8C]' : 'bg-white text-[#21201E] shadow-sm'"
        @click="$emit('toggle-mode', 'draw')"
      >
        Draw
      </button>
      <button
        class="flex-1 py-2 rounded-[8px] text-[0.8125rem] font-semibold transition-all"
        :class="mode === 'position' ? 'bg-white text-[#21201E] shadow-sm' : 'text-[#8C8C8C]'"
        @click="hasPhoto ? $emit('toggle-mode', 'position') : $emit('add-photo')"
      >
        {{ hasPhoto ? 'Photo' : 'Add Photo' }}
      </button>
    </div>

    <!-- Tier 2: Draw controls -->
    <template v-if="mode === 'draw'">
      <!-- Color Palette -->
      <div class="flex items-center gap-2 justify-center">
        <button
          v-for="color in colors"
          :key="color"
          class="w-8 h-8 rounded-full transition-all"
          :class="selectedColor === color ? 'scale-110' : ''"
          :style="{
            backgroundColor: color,
            border: '2.5px solid #42362B',
            boxShadow: selectedColor === color ? '0 0 0 2px #fff, 0 0 0 3.5px #42362B' : 'none',
          }"
          @click="$emit('color-change', color)"
        ></button>
        <label
          class="w-8 h-8 rounded-full border-2 transition-transform cursor-pointer flex items-center justify-center overflow-hidden"
          :class="isCustomColor ? 'border-[#42362B] scale-110' : 'border-[#D3D8DE]'"
          :style="{
            background: 'conic-gradient(red, yellow, lime, aqua, blue, magenta, red)',
          }"
        >
          <input
            type="color"
            :value="selectedColor"
            class="opacity-0 absolute w-0 h-0"
            @input="$emit('color-change', $event.target.value)"
          />
        </label>
      </div>

      <!-- Brush Size -->
      <div class="flex items-center gap-3">
        <div class="w-3 h-3 rounded-full bg-[#333]"></div>
        <input
          type="range"
          :value="brushSize"
          min="2"
          max="20"
          step="1"
          class="flex-1 accent-[#42362B]"
          @input="$emit('brush-size-change', parseInt($event.target.value))"
        />
        <div class="w-5 h-5 rounded-full bg-[#333]"></div>
      </div>
    </template>

    <!-- Tier 2: Photo controls -->
    <template v-else-if="mode === 'position' && hasPhoto">
      <p class="text-[0.8125rem] text-[#8C8C8C] text-center">
        Drag to move, pinch to zoom, twist to rotate
      </p>
      <div class="flex items-center gap-2 justify-center">
        <button
          class="px-4 py-1.5 rounded-[8px] text-sm font-medium bg-[#F6F5F1] text-[#637083]"
          @click="$emit('add-photo')"
        >
          Change Photo
        </button>
        <button
          class="px-4 py-1.5 rounded-[8px] text-sm font-medium bg-[#FDECEB] text-[#CC1100]"
          @click="$emit('remove-photo')"
        >
          Remove Photo
        </button>
      </div>
    </template>

    <!-- Action buttons slot (Undo/Clear + Save) -->
    <slot name="actions" />
  </div>
</template>

<script>
export default {
  name: 'DrawingToolbar',
  props: {
    selectedColor: {
      type: String,
      default: '#FF4444',
    },
    brushSize: {
      type: Number,
      default: 5,
    },
    hasPhoto: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'draw',
    },
  },
  emits: [
    'color-change',
    'brush-size-change',
    'undo',
    'clear',
    'add-photo',
    'toggle-mode',
    'remove-photo',
  ],
  data() {
    return {
      colors: [
        '#FF4444',
        '#FF8C00',
        '#FFD700',
        '#4CAF50',
        '#2196F3',
        '#9C27B0',
        '#FF69B4',
        '#FFFFFF',
        '#000000',
        '#8B4513',
      ],
    };
  },
  computed: {
    isCustomColor() {
      return !this.colors.includes(this.selectedColor);
    },
  },
};
</script>
